<template>
    <section aria-label="object-map">
        <div class="table-grid row">
            <div class="col">
                <img
                    v-if="data.icon?.fullpath"
                    :src="apiUrl + data.icon.fullpath"
                    width="30"
                />
            </div>
            <div class="col">
                {{ data.name }}
            </div>
            <div class="col">
                <v-btn depressed variant="text" x-small @click="showBigMap()">
                    <v-icon>mdi-map-marker-radius</v-icon>
                </v-btn>
            </div>

            <v-dialog
                max-width="900"
                v-model="dialog"
                persistent
            >
                <v-card>
                    <v-toolbar light>
                        <v-toolbar-title>Anfahrt</v-toolbar-title>
                        <v-btn fab depressed variant="text" @click="dialog = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text class="text-center">
                        <iframe
                            :src="data.location"
                            width="100%"
                            height="600"
                            style="border: 0"
                            allowfullscreen=""
                            loading="lazy"
                            referrerpolicy="no-referrer-when-downgrade"
                        />
                    </v-card-text>
                </v-card>
            </v-dialog>
        </div>
    </section>
</template>

<script setup>
import { defineProps, ref } from 'vue'

const apiUrl = process.env.VUE_APP_API_URL
const dialog = ref(false)

function showBigMap() {
    dialog.value = true;
}

defineProps({
    data: Object,
    item: Object,
    stepsMade: {
        type: Number,
        default: 0
    }
})
</script>
